import { type SxProps, type Theme } from '@mui/material';

const SUPPORTED_AUDIO_CONTENT_TYPE = ['audio/mpeg', 'audio/wav', 'audio/aac', 'audio/x-m4a'];

export const isSupportedAudioAttachmentContentType = (contentType: string) =>
  SUPPORTED_AUDIO_CONTENT_TYPE.includes(contentType);

// Min height (theme spacing units) shared by compact attachment pills and the
// "+N more" control so they read as the same size.
export const COMPACT_ATTACHMENT_MIN_HEIGHT = 3.75;

// Compact pill sizing, in theme spacing units. Widths are tuned so a few pills
// sit on a row instead of one wide card per line.
export const COMPACT_PILL_WIDTH = 15;
export const COMPACT_PILL_MIN_WIDTH = 11;
export const COMPACT_PILL_GAP = 0.375;

// The flex-wrap row and per-pill sizing are shared by the read-only display
// (MessageAttachments) and the editor's removable-pill row
// (EditableMessageAttachments) so both lay out identically.
export const attachmentRowSx: SxProps<Theme> = {
  alignItems: 'stretch',
  flexWrap: 'wrap',
  gap: COMPACT_PILL_GAP,
};

export const getAttachmentItemSx =
  (isWide: boolean): SxProps<Theme> =>
  (theme) => ({
    flex: isWide ? '1 0 100%' : `0 1 ${theme.spacing(COMPACT_PILL_WIDTH)}`,
    maxWidth: isWide ? '100%' : theme.spacing(COMPACT_PILL_WIDTH),
    minWidth: isWide ? '100%' : theme.spacing(COMPACT_PILL_MIN_WIDTH),
  });
